import { Container, Row, Col, Card } from "react-bootstrap";
import investifyImage from "../assets/investify.png";
import webImage from "../assets/webdev.png";
import dashboardImage from "../assets/cta-bg.png";

const projects = [
  {
    title: "Investify",
    type: "Concept Demo",
    description:
      "A mobile-first platform concept designed to help users discover and manage real estate investment opportunities.",
    image: investifyImage,
  },
  {
    title: "Inventory Management System",
    type: "Operations Solution",
    description:
      "A dashboard-driven system focused on stock visibility, reporting, and team coordination.",
    image: webImage,
  },
  {
    title: "Hospital Management Platform",
    type: "Healthcare Workflow",
    description:
      "A concept product for patient coordination, appointments, and internal operations.",
    image: dashboardImage,
  },
];

function Portfolio() {
  return (
    <div className="page-hero">
      <Container>
        <div className="text-center mb-4">
          <h1 className="hero-title">Selected projects</h1>
          <p className="section-lead mx-auto mt-3">
            These examples reflect the quality, clarity, and business focus we
            bring to digital products.
          </p>
        </div>
        <Row className="g-4">
          {projects.map((project) => (
            <Col md={4} key={project.title}>
              <Card className="project-card overflow-hidden h-100">
                <Card.Img
                  variant="top"
                  src={project.image}
                  height="240"
                  style={{ objectFit: "cover" }}
                />
                <Card.Body>
                  <div className="text-primary fw-semibold mb-2">
                    {project.type}
                  </div>
                  <Card.Title>{project.title}</Card.Title>
                  <Card.Text className="text-muted">
                    {project.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Portfolio;
